import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  CampaignStatusType, EntityTypeDetailsFragment, GetCampaignIdsGQL,
  GetEntityTypeGQL, SearchEntitiesPublic
} from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface PotentialDuplicateDialogData {
  campaignId: string;
  entity: SearchEntitiesPublic.Nodes;
}

@Component({
  selector: 'app-potential-duplicate-dialog',
  templateUrl: './potential-duplicate.dialog.html',
  styleUrls: ['./potential-duplicate.dialog.scss']
})
export class PotentialDuplicateDialog implements OnInit {
  entity: SearchEntitiesPublic.Nodes;
  entityType: EntityTypeDetailsFragment;
  isInCampaign: boolean;
  loading = true;
  displayedCampaignNames: string[] = [];
  notDisplayedCount = 0;

  constructor(
    public dialogRef: MatDialogRef<PotentialDuplicateDialog>,
    private _getCampaignIds: GetCampaignIdsGQL,
    private _getEntityTypeByIdGQL: GetEntityTypeGQL,
    private _cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: PotentialDuplicateDialogData
  ) {
    this.entity = data.entity;
    this.isInCampaign = this.entity.campaigns.map(c => c.id).includes(data.campaignId);
  }

  ngOnInit(): void {
    this._getEntityTypeByIdGQL.fetch({
      entityTypeId: this.entity.entityTypeId,
    }).subscribe(({ data }) => {
      this.entityType = data.getEntityType;
    });

    this._getCampaignIds.fetch({
      status: CampaignStatusType.Active
    }).subscribe(
      (res) => {
        const userAccessibleCampaignIds = res.data.searchCampaigns.matchingIds;
        const sharedCampaigns = this.entity.campaigns
          .filter(c => userAccessibleCampaignIds.includes(c.id))
          .map(c => c.name)
          .sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));

        // Map to copy reference
        this.displayedCampaignNames = sharedCampaigns.map(c => c);

        if (this.displayedCampaignNames.length === 0) {
          this.displayedCampaignNames.push('No campaigns');
        }

        if (sharedCampaigns.length > 11) {
          this.displayedCampaignNames = this.displayedCampaignNames.slice(0, 3);
          this.notDisplayedCount = sharedCampaigns.length - this.displayedCampaignNames.length;
        }

        this.loading = false;
        this._cd.markForCheck();
      }
    );
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }
}
